import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { Trans } from "@lingui/react/macro";

export const t_StartingPayment: Translatable = <Trans>Starting payment</Trans>;
export const t_RedirectingToPaymentGateway: Translatable = <Trans>Redirecting to payment gateway</Trans>;
export const t_CompletePaymentInPopupWindow: Translatable = (
    <Trans>Please complete the payment in the popup window</Trans>
);
export const t_WaitingForPaymentConfirmation: Translatable = <Trans>Waiting for payment confirmation</Trans>;

export const t_SavingInformation: Translatable = <Trans>Saving payment information</Trans>;
export const t_LoadingPaymentProvider: Translatable = <Trans>Loading payment provider</Trans>;

export const t_VerifyingPaymentMethod: Translatable = <Trans>Verifying payment method</Trans>;

export const t_ConnectingPaymentMethod: Translatable = <Trans>Connecting payment method</Trans>;
